'use client'

import { useLocale } from "@/contexts/locale-provider"
import LocaleSelector from "./locale-selector"

export default function MarketplaceFooter() {
  const { localeOptions, currentLocale } = useLocale()
  return (
    <footer className="border-t px-4 md:px-8 mx-auto max-w-screen-xl px-6">
      <div className="flex items-center py-4">
        <div className="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
          <LocaleSelector currentLocale={currentLocale} localeOptions={localeOptions} />
        </div>
      </div>
    </footer>
  )
}